import React from 'react';
import { Box} from '@chakra-ui/react';
import BillingInfo from './billings/BillingInfo';
import BillingPaymentInfo from './billings/PaymentInfo';
import BillingPaymentHistory from './billings/PaymentHistory';

export default function Billings() {
    return (
        <Box paddingX={'6'} paddingBottom='10'>
            <BillingInfo />
            <BillingPaymentInfo />
            <BillingPaymentHistory />
        </Box>  
    )
}